import $ from 'jquery';
import 'slick-carousel';
import { debounce } from 'underscore';

export default class HistorySlider {
	init() {
		const $stickyHeader = $('.sticky-header');
		const $slider = $('.history-slider');
		const $rangeButtons = $slider.find('.range-button');
		const $rangeContentElements = $slider.find('.range-content .range-element');
		let stickyHeaderHeight = $stickyHeader.outerHeight();
		const $win = $(window);

		$rangeButtons.click(function () {
			const toggleId = $(this).data('toggle-element');
			$rangeButtons.removeClass('active');
			$rangeButtons
				.find(`[data-toggle-element='${toggleId}']`)
				.addClass('active');
			$(`[data-toggle-element="${toggleId}"]`).addClass('active');
			toggleRange(toggleId);
		});

		initObserver();

		$win.resize(
			debounce(() => {
				reposition();
			}, 250),
		);

		function toggleRange(id) {
			$rangeContentElements.removeClass('active');
			$(id).addClass('active');
		}

		function initObserver() {
			const observer = new IntersectionObserver(
				([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
				{
					threshold: [1],
					rootMargin: `${-(stickyHeaderHeight + 50)}px 0px 50px 0px`,
				},
			);

			const dates = document.getElementsByClassName('date-header');
			for (let i = 0; i < dates.length; i++) {
				observer.observe(dates[i]);
			}
		}

		function reposition() {
			stickyHeaderHeight = $stickyHeader.outerHeight();
		}
	}
}
